import { call, put } from '@redux-saga/core/effects'
import axios from 'axios'
import apiAxios from '../../services/api'
import { DEBUG_LOGS, LOGIN_SIMULADO, LOGIN_PROD, ENVIAR_FOTOS_PARA_PROD} from '../../config/constants'
import { Types as SiteTypes } from '../ducks/site'

import { retornaPrimeiroNome } from '../../services/stringTool'

var FormData = require('form-data');


// Acessa WS e valida dados do login
function validarLoginNoWS(usuario, senha) {
    const BASE_URL_SERVER = 'https://websocket.romancemoda.com.br/'

    let REQUEST_URL
    const REQUEST_URL_PROD = 'WH/utils/validar_senha'
    const REQUEST_URL_TEST = 'WH_HMG/utils/validar_senha'

    if(LOGIN_PROD){
        REQUEST_URL = REQUEST_URL_PROD
    }else{
        REQUEST_URL = REQUEST_URL_TEST
    }

    const api = axios.create({
        baseURL: BASE_URL_SERVER,
        responseType: 'json',
    });

    const data = new FormData();
    data.append('USUARIO', usuario);
    data.append('SENHA', senha);

    return api.post(REQUEST_URL, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

// Altera STATE dos distribuidores de acordo com dados de login
function* asyncGetDistribuidores(action) {

    try {
        DEBUG_LOGS && console.log('asyncGetDistribuidores')

        // Instanciando dados
        const { usuario, senha } = action
        DEBUG_LOGS && console.log(action)

        let response
        if (!LOGIN_SIMULADO){
            // validando login no WS
            response = yield call(validarLoginNoWS, usuario, senha)
            
        }else{
            //! simulando um login
            response = {"data":{"ERRO": 0, "SUCESSO": true, "IDFILIAL": 121, "MSG": "OK", "USUARIOS": [{"IDPESSOA": 1215603, "APELIDO": null, "NOMEPESSOA": "AHLEN DOS SANTOS OLIVEIRA", "IDREPRESENTANTE": 51049, "USUARIO": "AHLENO"}, {"IDPESSOA": 1340181, "APELIDO": null, "NOMEPESSOA": "ALESSANDRA NAZARE PINTO FARIA", "IDREPRESENTANTE": 51223, "USUARIO": "ALESSANDRAFARIA"}, {"IDPESSOA": 90527, "APELIDO": null, "NOMEPESSOA": "ALEXANDRA PAULA FARIAS RIBEIRO", "IDREPRESENTANTE": 5130, "USUARIO": "ALEXANDRAR"}, {"IDPESSOA": 556396, "APELIDO": null, "NOMEPESSOA": "ALIETE KAMILA AQUINO LEAO", "IDREPRESENTANTE": 50270, "USUARIO": "ALIETEL"}, {"IDPESSOA": 50812, "APELIDO": null, "NOMEPESSOA": "ANDREIA JOSIENE NEGRAO COSTA", "IDREPRESENTANTE": 3844, "USUARIO": "ANDREIANC"}, {"IDPESSOA": 242, "APELIDO": null, "NOMEPESSOA": "ANNE CLEIA DOS SANTOS BARROS", "IDREPRESENTANTE": 2187, "USUARIO": "ANNEB"}, {"IDPESSOA": 240, "APELIDO": null, "NOMEPESSOA": "BENIGNO FERNANDES PIMENTEL FILHO", "IDREPRESENTANTE": 2083, "USUARIO": "BENIGNOF"}, {"IDPESSOA": 848156, "APELIDO": null, "NOMEPESSOA": "BRUNA KELLEM FREITAS PINTO DOS SANTOS", "IDREPRESENTANTE": 50700, "USUARIO": "BRUNAPS"}, {"IDPESSOA": 212572, "APELIDO": null, "NOMEPESSOA": "BRUNA TELES PARENTE PEREIRA", "IDREPRESENTANTE": 50573, "USUARIO": "BRUNAPP"}, {"IDPESSOA": 142416, "APELIDO": null, "NOMEPESSOA": "CARLA KAROLINE VILHENA  MARTA BAIA", "IDREPRESENTANTE": 50918, "USUARIO": "CARLABAIA"}, {"IDPESSOA": 177286, "APELIDO": null, "NOMEPESSOA": "CARLOS EDUARDO GONCALVES COSTA", "IDREPRESENTANTE": 5195, "USUARIO": "CARLOSC"}, {"IDPESSOA": 625293, "APELIDO": null, "NOMEPESSOA": "CARMEM LUCIA NUNES DE LIMA", "IDREPRESENTANTE": 50278, "USUARIO": "CARMEML"}, {"IDPESSOA": 279432, "APELIDO": null, "NOMEPESSOA": "CENIRA BRITO SILVA", "IDREPRESENTANTE": 49402, "USUARIO": "CENIRAS"}, {"IDPESSOA": 376089, "APELIDO": null, "NOMEPESSOA": "CHARLES FERNANDES DOS SANTOS", "IDREPRESENTANTE": 49734, "USUARIO": "CHARLESS"}, {"IDPESSOA": 796746, "APELIDO": null, "NOMEPESSOA": "CHRISTIANE MARIA SALES SANTOS", "IDREPRESENTANTE": 50555, "USUARIO": "CHRISTIANES"}, {"IDPESSOA": 211529, "APELIDO": null, "NOMEPESSOA": "CIRLEY PIMENTEL DA COSTA", "IDREPRESENTANTE": 49427, "USUARIO": "CIRLEYC"}, {"IDPESSOA": 225, "APELIDO": null, "NOMEPESSOA": "CLAUDIA HELENA DE OLIVEIRA FURTADO", "IDREPRESENTANTE": 2079, "USUARIO": "CLAUDIAHF"}, {"IDPESSOA": 163260, "APELIDO": null, "NOMEPESSOA": "CLEYCE KELEM MELO DA TRINDADE", "IDREPRESENTANTE": 50574, "USUARIO": "CLEYCET"}, {"IDPESSOA": 137240, "APELIDO": null, "NOMEPESSOA": "CYNTHIANNE CASCAES CARDOSO", "IDREPRESENTANTE": 51089, "USUARIO": "CYNTHIANNEC"}, {"IDPESSOA": 848155, "APELIDO": null, "NOMEPESSOA": "DANIELE MORAIS DOS SANTOS", "IDREPRESENTANTE": 51028, "USUARIO": "DANIELESANTOS"}, {"IDPESSOA": 1010683, "APELIDO": null, "NOMEPESSOA": "DANILO FREITAS DA SILVA", "IDREPRESENTANTE": 50863, "USUARIO": "DANILOS"}, {"IDPESSOA": 453521, "APELIDO": null, "NOMEPESSOA": "DEIZE JOYCE COSTA DE AVIZ", "IDREPRESENTANTE": 50624, "USUARIO": "DEIZEA"}, {"IDPESSOA": 978539, "APELIDO": null, "NOMEPESSOA": "DORIAN DA GRACA FERNANDES SILVA", "IDREPRESENTANTE": 50816, "USUARIO": "DORIANF"}, {"IDPESSOA": 34466, "APELIDO": null, "NOMEPESSOA": "EDINILCE CRISTINA MEDEIROS DE AMORIM", "IDREPRESENTANTE": 2583, "USUARIO": "EDINILCEM"}, {"IDPESSOA": 241, "APELIDO": null, "NOMEPESSOA": "ELAINE CRISTINA DE SOUZA DIAS", "IDREPRESENTANTE": 2148, "USUARIO": "ELAINESD"}, {"IDPESSOA": 60641, "APELIDO": null, "NOMEPESSOA": "ELENICE CRISTINA MEDEIROS DE AMORIM", "IDREPRESENTANTE": 49677, "USUARIO": "ELENICEA"}, {"IDPESSOA": 658889, "APELIDO": null, "NOMEPESSOA": "ELIENE GATINHO AMORIM", "IDREPRESENTANTE": 50469, "USUARIO": "ELIENEA"}, {"IDPESSOA": 363314, "APELIDO": null, "NOMEPESSOA": "ERIANE DA COSTA FERREIRA BRANCO", "IDREPRESENTANTE": 49941, "USUARIO": "ERIANEB"}, {"IDPESSOA": 193900, "APELIDO": null, "NOMEPESSOA": "EVALDO CONCEICAO DE OLIVEIRA", "IDREPRESENTANTE": 5204, "USUARIO": "EVALDOO"}, {"IDPESSOA": 423905, "APELIDO": null, "NOMEPESSOA": "FABIO FERNANDES DOS SANTOS", "IDREPRESENTANTE": 50011, "USUARIO": "FABIOS"}, {"IDPESSOA": 136953, "APELIDO": null, "NOMEPESSOA": "FLAVIO DE SOUZA ASSIS", "IDREPRESENTANTE": 5079, "USUARIO": "FLAVIOA"}, {"IDPESSOA": 244892, "APELIDO": null, "NOMEPESSOA": "FRANKANNE MAGALHAES PEREIRA DA MOTTA", "IDREPRESENTANTE": 49571, "USUARIO": "FRANKANNEM"}, {"IDPESSOA": 66414, "APELIDO": null, "NOMEPESSOA": "FRANKLINE MAGALHAES PEREIRA", "IDREPRESENTANTE": 5209, "USUARIO": "FRANKLINEP"}, {"IDPESSOA": 271048, "APELIDO": null, "NOMEPESSOA": "GILVETE NOGUEIRA DA COSTA", "IDREPRESENTANTE": 50130, "USUARIO": "GILVETEC"}, {"IDPESSOA": 273776, "APELIDO": null, "NOMEPESSOA": "GILZEIDE COSTA FERREIRA", "IDREPRESENTANTE": 50699, "USUARIO": "GILZEIDEF"}, {"IDPESSOA": 165340, "APELIDO": null, "NOMEPESSOA": "GISELE DA SILVA COUTO", "IDREPRESENTANTE": 49515, "USUARIO": "GISELEC"}, {"IDPESSOA": 357876, "APELIDO": null, "NOMEPESSOA": "GLEICE PINHEIRO DA SILVA", "IDREPRESENTANTE": 49915, "USUARIO": "GLEICES"}, {"IDPESSOA": 700917, "APELIDO": null, "NOMEPESSOA": "GLEYCE RODRIGUES MENDES", "IDREPRESENTANTE": 50411, "USUARIO": "GLEIYCEM"}, {"IDPESSOA": 316975, "APELIDO": null, "NOMEPESSOA": "IGOR RANIERI RIBEIRO MONTEIRO", "IDREPRESENTANTE": 49438, "USUARIO": "IGORM"}, {"IDPESSOA": 1234615, "APELIDO": null, "NOMEPESSOA": "JACIMARA DOLORES MARQUES FALCAO", "IDREPRESENTANTE": 51073, "USUARIO": "JACIMARAF"}, {"IDPESSOA": 354553, "APELIDO": null, "NOMEPESSOA": "JANAINA CONCEICAO SILVA FARIAS", "IDREPRESENTANTE": 49615, "USUARIO": "JANAINAF"}, {"IDPESSOA": 55225, "APELIDO": null, "NOMEPESSOA": "JANE PRICILA NASCIMENTO DA SILVA", "IDREPRESENTANTE": 4006, "USUARIO": "JANES"}, {"IDPESSOA": 36417, "APELIDO": null, "NOMEPESSOA": "JIZELLE ALBUQUERQUE DA ROCHA", "IDREPRESENTANTE": 49588, "USUARIO": "JIZELLER"}, {"IDPESSOA": 498416, "APELIDO": null, "NOMEPESSOA": "JOELMA FLORIANO DOS SANTOS DE SOUSA", "IDREPRESENTANTE": 50844, "USUARIO": "JOELMAS"}, {"IDPESSOA": 818838, "APELIDO": null, "NOMEPESSOA": "JOSSEANE SILVA DOS SANTOS", "IDREPRESENTANTE": 51196, "USUARIO": "JOSSEANES"}], "NOMEPESSOA": "Jaciane"}}
        }
        DEBUG_LOGS && console.log(response)

        if (response.data.MSG) {
            DEBUG_LOGS && console.log(response.data.SUCESSO)
            if (response.data.SUCESSO === true) {

                const distribuidores = response.data.USUARIOS
                const nomePessoa = retornaPrimeiroNome(response.data.NOMEPESSOA)
                DEBUG_LOGS && console.log(nomePessoa)

                yield put({
                    type: SiteTypes.SET_USUARIO,
                    usuario, nomePessoa
                })

                sessionStorage.setItem('@EnviaFotoComprovante:usuario', usuario);
                sessionStorage.setItem('@EnviaFotoComprovante:senha', senha);

                yield put({
                    type: SiteTypes.GET_DISTRIBUIDORES_SUCCESS,
                    distribuidores
                })

                // confere se tem distribuidor selecionado no local
                const localDistribuidor = JSON.parse(sessionStorage.getItem('@EnviaFotoComprovante:distribuidor'));

                if(localDistribuidor){
                    yield put({
                        type: SiteTypes.SET_DISTRIBUIDOR,
                        distribuidor: localDistribuidor
                    })

                    yield put({
                        type: SiteTypes.ASYNC_GET_SOLICITACOES,
                        idRepresentante: localDistribuidor.IDREPRESENTANTE
                    })
                }

            } else
                yield put({
                    type: SiteTypes.GET_DISTRIBUIDORES_FAILURE,
                    errorMessage: 'Usuario ou senha inválidos, por favor tente novamente.'
                })
        } else {
            yield put({
                type: SiteTypes.GET_DISTRIBUIDORES_FAILURE,
                errorMessage: 'Erro interno de conexão com o servidor.'
            })
        }


        // pega o response e se der certo atualiza state com "put"

    } catch (err) {


        DEBUG_LOGS && console.log(err)
        DEBUG_LOGS && console.log(err.status)
        DEBUG_LOGS && console.log(err.message)

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        DEBUG_LOGS && console.log(connection);

        // teste de conectividade
        let temInternet = true
        if (connection.rtt === 0) {
            temInternet = false
        } else if (err.message === 'Network Error') {
            temInternet = false
        }
        (temInternet)
            ? yield put({
                type: SiteTypes.GET_DISTRIBUIDORES_FAILURE,
                menssagemDeErro: 'Houve uma falha de conexão.'
            })
            : yield put({
                type: SiteTypes.GET_DISTRIBUIDORES_FAILURE,
                menssagemDeErro: 'Houve uma falha de conexão.'
            })
    }
}

// function que altera o distribuidor atual no state
function* asyncSetDistribuidor(action) {
    const { distribuidor } = action

    sessionStorage.setItem('@EnviaFotoComprovante:distribuidor', JSON.stringify(distribuidor));

    yield put({
        type: SiteTypes.SET_DISTRIBUIDOR,
        distribuidor
    })

    yield put({
        type: SiteTypes.ASYNC_GET_SOLICITACOES,
        idRepresentante: distribuidor.IDREPRESENTANTE
    })
}

// rota do backend de upload (o mesmo servidor responde as solicitacoes)
function uriUpload() {
    return ENVIAR_FOTOS_PARA_PROD ? 'upload' : 'dev/upload'
}

function buscarSolicitacoes(idRepresentante) {
    return apiAxios.get(uriUpload() + '/solicitacoes', {
        // incluir_lancados: tambem os depositos lancados no Gerenciador Financeiro (app 2650) aguardando foto
        params: { id_representante: idRepresentante, incluir_lancados: 1 }
    })
}

/**
 * Versao da solicitacao de deposito do distribuidor. Na V2 (3) o comprovante precisa
 * ser vinculado a uma solicitacao, entao o front lista as que aguardam comprovante.
 */
function* asyncGetSolicitacoes(action) {
    try {
        const response = yield call(buscarSolicitacoes, action.idRepresentante)
        DEBUG_LOGS && console.log(response)

        if (response.data.erro === 0) {
            yield put({
                type: SiteTypes.GET_SOLICITACOES_SUCCESS,
                versao: response.data.versao,
                solicitacoes: response.data.solicitacoes || []
            })
        } else {
            yield put({
                type: SiteTypes.GET_SOLICITACOES_FAILURE,
                erroSolicitacoes: response.data.mensagem_erro || 'Não foi possível consultar as solicitações do distribuidor.'
            })
        }
    } catch (err) {
        DEBUG_LOGS && console.log(err)

        yield put({
            type: SiteTypes.GET_SOLICITACOES_FAILURE,
            erroSolicitacoes: 'Houve uma falha de conexão ao consultar as solicitações do distribuidor.'
        })
    }
}

// function que altera o distribuidor atual no state
function* asyncToggleLogin(action) {

    yield put({
        type: SiteTypes.TOGGLE_LOGIN
    })
}

// function que altera o distribuidor atual no state
function* asyncClearDistribuidor(action) {

    yield put({
        type: SiteTypes.CLEAR_DISTRIBUIDOR
    })
}

// function que altera o distribuidor atual no state
function* asyncResetaLogs(action) {
    //console.log('asyncResetaLogs')
    yield put({
        type: SiteTypes.RESETA_LOGS
    })
}

function enviarFotoParaWS(dados) {

    var date = new Date();
    var aaaa = date.getFullYear();
    var gg = date.getDate();
    var mm = (date.getMonth() + 1);

    if (gg < 10)
        gg = "0" + gg;

    if (mm < 10)
        mm = "0" + mm;

    var dateTimeAtual = String(aaaa) + String(mm) + String(gg);

    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds();

    if (hours < 10)
        hours = "0" + hours;

    if (minutes < 10)
        minutes = "0" + minutes;

    if (seconds < 10)
        seconds = "0" + seconds;

    dateTimeAtual = dateTimeAtual + String(hours) + String(minutes) + String(seconds)


    const { imagemBase64, id_distribuidor, usuario, id_requisicao, tipo_pagamento, id_deposito } = dados
    DEBUG_LOGS && console.log(imagemBase64)

    const nome_da_imagem = id_distribuidor + '_0000_' + dateTimeAtual

    return apiAxios.post(uriUpload(), {
        headers: {
            'Content-Type': `application/json`,
        },
        data: {
            id: '0',
            id_representante: id_distribuidor,
            usuario: usuario,
            file: imagemBase64,
            filename: nome_da_imagem + '.jpeg',
            nome_da_foto: nome_da_imagem + '.jpeg',
            // solicitacao V2 escolhida (vazio = fluxo antigo)
            id_requisicao: id_requisicao || '',
            // deposito escolhido; sem id_requisicao (lancado na 2650) o backend o vincula a uma solicitacao V2
            id_deposito: id_deposito || '',
            tipo_pagamento: tipo_pagamento || ''
        }
    })
}

/**
 * funcao responsavel por receber imagem base64 do comprovante e envia para o WS
 */
function* asyncEnviaFotoParaWs(action) {
    DEBUG_LOGS && console.log('init asyncEnviaFotoParaWs')
    try {
        // instanciando dados
        let { imagemBase64 } = action

        // remove metadata desnecessária da foto
        imagemBase64 = imagemBase64.slice(23)

        const dados = {
            ...action, imagemBase64: imagemBase64
        }

        DEBUG_LOGS && console.log('dados')
        DEBUG_LOGS && console.log(dados)


        const response = yield call(enviarFotoParaWS, dados)
        DEBUG_LOGS && console.log('response')
        DEBUG_LOGS && console.log(response)

        response.data.comprovante_valido
            ? yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_SUCCESS
            })
            : yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: response.data.mensagem_erro
            })


    } catch (err) {

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        DEBUG_LOGS && console.log(connection);

        // teste de conectividade
        let temInternet = true
        if (connection.rtt === 0) {
            temInternet = false
        } else if (err.message === 'Network Error') {
            temInternet = false
        }
        (!temInternet)
            ? yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: 'Houve uma falha de conexão.'
            })
            : yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: 'Houve uma falha de conexão.'
            })
    }
}

function enviarArquivoParaWS(dados) {

    var date = new Date();
    var aaaa = date.getFullYear();
    var gg = date.getDate();
    var mm = (date.getMonth() + 1);

    if (gg < 10)
        gg = "0" + gg;

    if (mm < 10)
        mm = "0" + mm;

    let dateTimeAtual = String(aaaa) + String(mm) + String(gg);

    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds();

    if (hours < 10)
        hours = "0" + hours;

    if (minutes < 10)
        minutes = "0" + minutes;

    if (seconds < 10)
        seconds = "0" + seconds;

    dateTimeAtual = dateTimeAtual + String(hours) + String(minutes) + String(seconds)


    const { arquivo, id_distribuidor, usuario, id_requisicao, tipo_pagamento, id_deposito } = dados


    const nome_da_imagem = id_distribuidor + '_0000_' + dateTimeAtual
    DEBUG_LOGS && console.log(nome_da_imagem + '.jpeg')
    DEBUG_LOGS && console.log('arquivo')
    DEBUG_LOGS && console.log(arquivo)

    const data = new FormData();
    data.append('file', arquivo);
    data.append('id', '0');
    data.append('id_representante', id_distribuidor);
    data.append('usuario', usuario);
    data.append('filename', nome_da_imagem + '.jpeg');
    data.append('nome_da_foto', nome_da_imagem + '.jpeg');
    // solicitacao V2 escolhida (vazio = fluxo antigo)
    data.append('id_requisicao', id_requisicao || '');
    data.append('id_deposito', id_deposito || '');
    data.append('tipo_pagamento', tipo_pagamento || '');

    return apiAxios.post(uriUpload(), data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

/**
 * funcao responsavel por receber imagem base64 do comprovante e envia para o WS
 */
function* asyncEnviaArquivoParaWs(action) {
    DEBUG_LOGS && console.log('init asyncEnviaArquivoParaWs')
    try {
        // instanciando dados
        let { arquivo } = action

        const dados = {
            ...action, arquivo: arquivo
        }

        const response = yield call(enviarArquivoParaWS, dados)
        DEBUG_LOGS && console.log('response')
        DEBUG_LOGS && console.log(response)
        DEBUG_LOGS && console.log(response.data.comprovante_valido)

        response.data.comprovante_valido
            ? yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_SUCCESS
            })
            : yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: response.data.mensagem_erro
            })


    } catch (err) {
        DEBUG_LOGS && console.log('err')

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        DEBUG_LOGS && console.log(connection);

        // teste de conectividade
        let temInternet = true
        if (connection.rtt === 0) {
            temInternet = false
        } if (err.message === 'Network Error') {
            temInternet = false
        }
        (temInternet)
            ? yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: 'Houve uma falha de conexão.'
            })
            : yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: 'Houve uma falha de conexão.'
            })

        /*
        (temInternet)
            ? yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: 'Houve uma falha interna no servidor.'
            })
            : yield put({
                type: SiteTypes.ENVIA_FOTO_PARA_WS_FAILURE,
                menssagemDeErro: 'Houve uma falha na conexão com a internet.'
            })
        */


        DEBUG_LOGS && console.log(err)
        DEBUG_LOGS && console.log(err.status)
        DEBUG_LOGS && console.log(err.message)
        DEBUG_LOGS && console.log('error handling')
        // Error
        if (err.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            DEBUG_LOGS && console.log(err.response.data);
            DEBUG_LOGS && console.log(err.response.status);
            DEBUG_LOGS && console.log(err.response.headers);
        } else if (err.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            DEBUG_LOGS && console.log(err.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            DEBUG_LOGS && console.log('Error', err.message);
        }
        DEBUG_LOGS && console.log(err.config);
        DEBUG_LOGS && console.log('error json object')
        DEBUG_LOGS && console.log(JSON.parse(JSON.stringify(err)))

    }
}

/**
 * funcao responsavel por receber imagem base64 do comprovante e envia para o WS
 */
function* asyncSetFotoAtual(action) {
    DEBUG_LOGS && console.log('asyncSetFotoAtual')
    DEBUG_LOGS && console.log(action)

    // seta foto atual no state
    yield put({
        type: SiteTypes.SET_FOTO_ATUAL,
        foto: action.foto
    })
}

export {
    asyncGetDistribuidores,
    asyncSetDistribuidor,
    asyncToggleLogin,
    asyncClearDistribuidor,
    asyncEnviaFotoParaWs,
    asyncResetaLogs,
    asyncEnviaArquivoParaWs,
    asyncSetFotoAtual,
    asyncGetSolicitacoes,
}